<template>

  <div>
    <b-modal
      id="modal-no-backdrop"
      ref="myModal"
      content-class="shadow"
      no-close-on-backdrop
      hide-header
    >
      <p class="mt-1">
        {{ $t('notice_text.traders') }}
      </p>
      <p class="my-2 text-justify">
        {{ $t('notice_text.description') }}
      </p>
      <p>{{ $t('notice_text.thanks') }}</p>
      <template #modal-footer="{ ok }">
        <b-button
          size="sm"
          variant="success"
          @click="ok()"
        >
          {{ $t('notice_text.btn') }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
import notice from '@/views/logics/components/notice'

export default {
  mixins: [notice],
}
</script>
